import {Directive,ElementRef,EventEmitter,HostBinding,HostListener,Output} from '@angular/core';
import {LOGO_SURFACES,LogoSurface,preferredLogoSurface} from './logo-contrast';

@Directive({selector:'img[appLogoContrast]',standalone:true})
export class LogoContrastDirective {
  @HostBinding('style.backgroundColor') background=LOGO_SURFACES.light;
  @Output() logoSurface=new EventEmitter<LogoSurface>();
  constructor(private element:ElementRef<HTMLImageElement>) {}
  @HostListener('load') analyze():void {
    let surface:LogoSurface='light';
    try {
      const image=this.element.nativeElement;
      if(image.naturalWidth&&image.naturalHeight) {
        const scale=Math.min(1,64/image.naturalWidth,64/image.naturalHeight);
        const canvas=document.createElement('canvas');canvas.width=Math.max(1,Math.round(image.naturalWidth*scale));canvas.height=Math.max(1,Math.round(image.naturalHeight*scale));
        const context=canvas.getContext('2d',{willReadFrequently:true});
        if(context){context.drawImage(image,0,0,canvas.width,canvas.height);surface=preferredLogoSurface(context.getImageData(0,0,canvas.width,canvas.height).data,canvas.width,canvas.height);}
      }
    } catch { /* An unavailable canvas must never hide the company logo. */ }
    this.background=LOGO_SURFACES[surface];this.logoSurface.emit(surface);
  }
}
